var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Suspense, useEffect, useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Alert, AlertTitle, FormGroup, FormLabel, IconButton, InputAdornment, Link as MuiLink, Stack } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { emailValidator } from "../utils/form.util";
var LoginFormTip = React.lazy(function () { return import('././LoginFormSuspenseTip'); });
export default function LoginForm(props) {
    var _this = this;
    var _a, _b;
    var t = useTranslation().t;
    var _c = useState((_a = props.initialEmail) !== null && _a !== void 0 ? _a : ''), email = _c[0], setEmail = _c[1];
    var _d = useState(''), emailError = _d[0], setEmailError = _d[1];
    var _e = useState((_b = props.initialPassword) !== null && _b !== void 0 ? _b : ''), password = _e[0], setPassword = _e[1];
    var _f = useState(''), passwordError = _f[0], setPasswordError = _f[1];
    var _g = useState(false), showPassword = _g[0], setShowPassword = _g[1];
    var emailClean = email.trim().toLowerCase();
    var hasPrefilledCredentials = !!(props.initialEmail && props.initialPassword);
    // Login must not enforce password policy here because self service sign up users can have 1-character passwords.
    var emailHasError = !emailClean || (!hasPrefilledCredentials && !!emailValidator(emailClean));
    var formError = emailHasError || !password;
    var loginMut = useMutation('login', function (overrides) { return __awaiter(_this, void 0, void 0, function () {
        var loginEmail, loginPassword;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    loginEmail = (_a = overrides === null || overrides === void 0 ? void 0 : overrides.email) !== null && _a !== void 0 ? _a : emailClean;
                    loginPassword = (_b = overrides === null || overrides === void 0 ? void 0 : overrides.password) !== null && _b !== void 0 ? _b : password;
                    if (!overrides && formError) {
                        if (!loginEmail) {
                            setEmailError(t('Please enter your email'));
                        }
                        else if (!hasPrefilledCredentials && emailValidator(loginEmail)) {
                            setEmailError(t('Please enter a valid email'));
                        }
                        if (!loginPassword) {
                            setPasswordError(t('Please enter your password'));
                        }
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, props.executeLogin(loginEmail, loginPassword)];
                case 1:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    }); });
    // Instant login (see autoSubmit prop): fire the login once on mount, guarded by a
    // ref so a failed attempt doesn't retry in a loop and the user can correct the form.
    var autoSubmitted = useRef(false);
    useEffect(function () {
        if (props.autoSubmit && hasPrefilledCredentials && !autoSubmitted.current) {
            autoSubmitted.current = true;
            loginMut.mutate(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsxs(Stack, __assign({ sx: {
            width: '100%',
            maxWidth: '400px',
            padding: '24px',
            gap: 3
        } }, { children: [props.logoUrl && (_jsx(Stack, __assign({ alignItems: 'center', mb: 2 }, { children: _jsx("img", { src: props.logoUrl, alt: 'Logo', style: {
                        maxHeight: 80,
                        maxWidth: 200,
                        objectFit: 'contain',
                    } }) }))), _jsx(Stack, __assign({ gap: 1 }, { children: _jsx(Typography, __assign({ variant: "h6", textAlign: 'start' }, { children: t('Sign in') })) })), _jsxs(Stack, __assign({ component: "form", onSubmit: function (e) {
                    e.preventDefault();
                    loginMut.mutate(undefined);
                }, noValidate: true }, { children: [_jsxs(Stack, __assign({ gap: '12px', width: '100%' }, { children: [_jsxs(FormGroup, __assign({ sx: { alignItems: 'flex-start', gap: '2px' } }, { children: [_jsx(FormLabel, { children: t('Email') }), _jsx(TextField, { variant: 'outlined', margin: "none", required: true, fullWidth: true, id: "input-email", name: "email", autoComplete: "email", inputMode: 'email', autoFocus: true, size: 'small', value: email, onChange: function (e) {
                                            setEmail(e.target.value);
                                            if (emailError) {
                                                setEmailError('');
                                            }
                                        }, error: !!emailError, helperText: emailError })] })), _jsxs(FormGroup, __assign({ sx: { alignItems: 'flex-start', gap: '2px' } }, { children: [_jsx(FormLabel, { children: t('Password') }), _jsx(TextField, { variant: 'outlined', margin: "none", required: true, fullWidth: true, id: "input-password", name: "password", autoComplete: "current-password", inputMode: 'text', size: 'small', value: password, type: showPassword ? 'text' : 'password', error: !!passwordError, helperText: passwordError, onChange: function (e) {
                                            setPassword(e.target.value);
                                            if (passwordError) {
                                                setPasswordError('');
                                            }
                                        }, InputProps: {
                                            endAdornment: (_jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(IconButton, __assign({ onClick: function () { return setShowPassword(function (prev) { return !prev; }); }, edge: "end", size: "small" }, { children: showPassword ? _jsx(VisibilityOff, { fontSize: "small" }) :
                                                        _jsx(Visibility, { fontSize: "small" }) })) }))),
                                        } })] }))] })), _jsx(LoadingButton, __assign({ id: 'btn-login', type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, disabled: loginMut.isLoading || formError, loading: loginMut.isLoading }, { children: t('Sign In') })), !loginMut.isLoading && loginMut.isError &&
                        _jsxs(Alert, __assign({ id: 'msg-login-error', severity: "error", variant: 'filled', sx: { mb: 2 } }, { children: [_jsx(AlertTitle, { children: t('Login failed.') }), _jsx(Typography, { children: t('Please check your email and password and try again.') })] })), props.showReset && _jsx(MuiLink, __assign({ component: Link, to: "/identity/password/reset", alignSelf: 'flex-start', sx: { cursor: 'pointer' }, underline: "hover" }, { children: t('Forgot password') }))] })), process.env.NODE_ENV === 'development' && props.showDemoCredentialsTip === true && (_jsx(Suspense, __assign({ fallback: null }, { children: _jsx(LoginFormTip, { loading: loginMut.isLoading, onChange: function (email, password) {
                        setEmail(email);
                        setPassword(password);
                        setEmailError('');
                        setPasswordError('');
                        loginMut.mutate({ email: email, password: password });
                    } }) })))] })));
}
